import moment from 'moment';

const timestamp = (value: string, format: string = 'DD MMMM, YYYY'): string => {
  if (moment(value).isValid()) {
    return moment(value).format(format);
  } else return 'No Date';
};

export default timestamp;
